import React from 'react';
import { useParams } from 'react-router-dom';
import Loader from '../../../components/Loader';
import useFetchTransactions from '../../../hooks/admin/useFetchTransactions';
import AdTable from '../components/AdTable';

const Index = () => {
  const { company } = useParams();
  const { data, columns, loading, error } = useFetchTransactions(
    { company },
    'datatable'
  );

  return (
    <div>
      {loading ? (
        <Loader />
      ) : error ? (
        <h1>Error fetching data</h1>
      ) : (
        <AdTable
          data={data}
          columns={columns}
          font='transacción'
        />
      )}
    </div>
  );
};

export default Index;
